@if (isLoading()) {
  <app-spinner></app-spinner>
}
<ngx-app-bar
  class="w-100"
  [title]="'سوالات متداول'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="d-flex justify-content-center">
  <div class="w-100 px-plus">
    <app-tabs
      (onTabChange)="onTabChanged()"
      [defaultActiveTabIndex]="0"
    >
      <app-tab tabTitle="صندوق درامد ثابت">
        <div class="w-100 d-flex flex-wrap mt-medium">
          @for (faq of faqs()?.['fixedIncome']; track faq; let last = $last) {
            <app-faq-item
              [data]="faq"
              [isLastItem]="last"
            ></app-faq-item>
          }
        </div>
      </app-tab>
      <app-tab tabTitle="صندوق سهامی">
        <div class="w-100 d-flex flex-wrap mt-medium">
          @for (faq of faqs()?.['stock']; track faq; let last = $last) {
            <app-faq-item
              [data]="faq"
              [isLastItem]="last"
            ></app-faq-item>
          }
        </div>
      </app-tab>
    </app-tabs>
  </div>
</div>
